import script from "./ProductosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductosView.vue?vue&type=script&setup=true&lang=js"

import "./ProductosView.vue?vue&type=style&index=0&id=842d6500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-842d6500"]])

export default __exports__